import { IMPROVEMENT_OPPORTUNITY_METRICS } from '@src/utils/kpi';
import React, { useEffect, useMemo } from 'react';
import BaseChart, { useChartInstance } from '@src/components/common/BaseChart';
import { buildMultiChartOption } from '../../utils/chartOptions';
import { filterColors } from '@src/utils/colorPalette';
import { ChartWrapper } from '../styled';

const colorMap = {};
IMPROVEMENT_OPPORTUNITY_METRICS.forEach((m, idx) => {
  colorMap[m] = filterColors[idx % filterColors.length];
});

function OpportunitiesTrend({ data = {} }) {
  const { instance, chartInstanceRefCb } = useChartInstance({});
  const chartOption = useMemo(
    () => buildMultiChartOption({ data, metrics: IMPROVEMENT_OPPORTUNITY_METRICS, colorMap }),
    [data],
  );

  useEffect(() => {
    if (instance) {
      instance.setOption(chartOption);
    }
  }, [instance, chartOption]);

  return (
    <ChartWrapper>
      <BaseChart chartInstanceRefCb={chartInstanceRefCb} style={{ height: 210, width: '100%' }} />
    </ChartWrapper>
  );
}

export default OpportunitiesTrend;
